import { render, staticRenderFns } from "./jikajilu.vue?vue&type=template&id=502aae56"
import script from "./jikajilu.vue?vue&type=script&lang=js"
export * from "./jikajilu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports